import Highcharts from 'highcharts';
import i18n from '../../../../utils/ChrI18n';
import { getExportFileName } from '../utils';

const getChartConfig = function(data) {
  const seriesData = Object.values(data.seriesData);

  return {
    chart: {
      height: '300px',
      zoomType: 'x',
      events: {
        exportData: function (data) {
          // TODO_ADMIN_DASHBOARD_REVAMP : The CSV export date may not precisely match the date range displayed in the UI. This issue could be addressed once daily and monthly formats are integrated.
          data.dataRows.forEach((dataRow, index) => {
            index && (dataRow[0] = new Date(dataRow[0]).toDateString());
          });
        },
      }
    },
    tooltip: {
      enabled: true,
      useHTML: true,
      outside: true,
      formatter: function() { // TODO_ADMIN_DASHBOARD_REVAMP : handle monthly date format
        const date = GroupsReport.getHighChartsDateFormat(data.interval, this.x, data.pointStart, data.pointEnd, Highcharts);
        const text = GroupsReport.getLabelWithValue(this.series.userOptions.tooltipLabel, this.y, Highcharts);
        return GroupsReport.getToolipTextFormattedWithDate(date, text);
      }
    },
    legend: GroupsReport.legendConfiguration,
    xAxis: {
      lineWidth: 0,
      gridLineDashStyle: 'longDash',
      title: { text: null },
      type: 'datetime',
      gridLineWidth: 1
    },
    yAxis: {
      title: { text: null },
      gridLineWidth: 0,
      allowDecimals: false,
    },
    plotOptions: {
      series: {
        pointStart: data.pointStart,
        pointInterval: data.pointInterval
      }
    },
    exporting: {
      filename: getExportFileName(i18n.t("widgets.membership_requests_received.title"))
    },
    series: seriesData
  };
}

export default getChartConfig;